import Guard from 'arg-guard'

import Logger from '../logger'
import Segment from './segment'

/**
 * Defined structure of a segment.
 *
 * @export Home
 * @class Home
 */
export default class Home {

    /**
     * Creates an instance of a Home.
     * @param {Object} data Source data - From API or state.
     * @memberof Home
     */
    constructor(data) {
        Guard.throwIf(data, 'data')

        this.baseResult = data.baseResult
        this.summaryBullets = data.propertySummaryBullets
        this.segments = data.surveySegments.map(item => Segment.ensure(item))

        if (data.buildingParts && data.buildingParts.length) {
            data.buildingParts[0].surveySegments.map(item => Segment.ensure(item))
                .forEach(segment => this.segments.push(segment))

            // Add any additional building parts.
            this.segments.forEach(segment => this._addSegmentParts(segment, data.buildingParts.slice(1)))
        }

        if (data.psmaAttributionInfo) {
            this.psmaAttributionInfo = {}
            if (data.psmaAttributionInfo.year)
                this.psmaAttributionInfo.year = data.psmaAttributionInfo.year
            if (data.psmaAttributionInfo.licenceNumber)
                this.psmaAttributionInfo.licenceNumber = data.psmaAttributionInfo.licenceNumber
            if (data.psmaAttributionInfo.councilPartner)
                this.psmaAttributionInfo.councilPartner = data.psmaAttributionInfo.councilPartner
        }

        Logger.logObject(this, 'Home created', 'MyHome')
    }

    /**
     * Adds building part elements to a child segment.
     *
     * @param {Segment} segment The segment to add parts too.
     * @param {Array} otherBuildingParts
     * @memberof Home
     */
    _addSegmentParts(segment, otherBuildingParts) {
        otherBuildingParts.forEach(part => {
            const otherSegment = part.surveySegments.find(s => s.key === segment.$key)

            if (otherSegment && otherSegment.items && otherSegment.items.length) {
                segment.data.push(...otherSegment.items.map(os => {
                    os.partIndex = part.partIndex
                    return os
                }))
            }
        })
    }

    /**
     * Ensures that the provided data is already of this type. If not, it runs the constructor.
     *
     * @static
     * @param {Object} data Source data - From API or state.
     * @returns {Home} Either the data is passed back if already of this type or the result of the constructor is.
     * @memberof Home
     */
    static ensure(data) {
        return data && data instanceof Home ? data : new Home(data)
    }
}
